import { Alert, styled, useIsClient } from '@showroomjs/ui';
import * as React from 'react';
import { GenericLink } from './generic-link';
export const DocPlaceholder = styled(function DocPlaceholder(props) {
    const isClient = useIsClient();
    return isClient ? (React.createElement("div", { className: props.className },
        React.createElement(Alert, { variant: "info" },
            React.createElement("div", null,
                React.createElement(P, null, "There is no documentation/example for this component."),
                process.env.NODE_ENV === 'development' && (React.createElement(React.Fragment, null,
                    React.createElement(P, null, "Create a file at the following location to start adding documentation/example:"),
                    React.createElement(P, null,
                        React.createElement("code", null, props.componentFilePath.replace(/(\.(js|ts|jsx|tsx))$/, '.mdx'))),
                    React.createElement("p", null,
                        "To learn more about creating documentation/example for your component, visit",
                        ' ',
                        React.createElement(Link, { href: "https://react-showroom.js.org/getting-started/documenting-components#show-usages-with-markdown" }, "this page"),
                        "."))))))) : null;
}, {
    marginY: '$4',
});
const Link = styled(GenericLink, {
    textDecoration: 'underline',
});
const P = styled('p', {
    marginBottom: '$2',
});
//# sourceMappingURL=doc-placeholder.js.map